const drawer = function () {
  if (!Element.prototype.closest) {
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function (s) {
      const el = this;
      let ancestor = this;
      if (!document.documentElement.contains(el)) return null;
      do {
        if (ancestor.matches(s)) return ancestor;
        ancestor = ancestor.parentElement;
      } while (ancestor !== null);
      return null;
    };
  }

  function trapFocus(element) {
    const focusableEls = element.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    );
    const firstFocusableEl = focusableEls[0];
    const lastFocusableEl = focusableEls[focusableEls.length - 1];
    const KEYCODE_TAB = 9;

    element.addEventListener("keydown", function (e) {
      const isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          e.preventDefault();
        }
      } /* tab */ else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          e.preventDefault();
        }
      }
    });
  }

  const settings = {
    speedOpen: 0,
    speedClose: 0,
    activeClass: "is-active",
    visibleClass: "is-visible",
    selectorTarget: "[data-drawer-target]",
    selectorTrigger: "[data-drawer-trigger]",
    selectorClose: "[data-drawer-close]",
  };

  // Toggle accessibility
  const toggleAccessibility = function (event) {
    if (event.getAttribute("aria-expanded") === "true") {
      event.setAttribute("aria-expanded", false);
    } else {
      event.setAttribute("aria-expanded", true);
    }
  };

  // Open Drawer
  const openDrawer = function (trigger) {
    const target = document.getElementById(
      trigger.getAttribute("aria-controls")
    );
    const wrapper = target.querySelector(".drawer__wrapper");
    const scrollTo = trigger.getAttribute("scroll-to");

    target.classList.add(settings.activeClass);
    document.documentElement.style.overflow = "hidden";
    document.getElementById("MainContent").classList.add("open-drawer");
    document.body.classList.add("drawer-open");
    if (trigger.getAttribute("aria-controls") == "drawer-name") {
      document.body.classList.add("drawer-open-drawer-name");
    }
    toggleAccessibility(trigger);
    setTimeout(function () {
      target.classList.add(settings.visibleClass);
      trapFocus(target);
      if (scrollTo) {
        const element = target.querySelector(scrollTo);
        wrapper.scrollTo({ top: element.offsetTop, behavior: "smooth" });
      }
    }, settings.speedOpen);
  };
  // Close Drawer
  const closeDrawer = function (event) {
    const closestParent = event.closest(settings.selectorTarget),
      childrenTrigger = document.querySelector(
        '[aria-controls="' + closestParent.id + '"'
      );
    closestParent.classList.remove(settings.visibleClass);

    setTimeout(() => {
      document.documentElement.style.overflow = "";
      document.getElementById("MainContent").classList.remove("open-drawer");
      if (document.body.classList.contains("drawer-open")) {
        document.body.classList.remove("drawer-open");
      }
      if (document.body.classList.contains("drawer-open-drawer-name")) {
        document.body.classList.remove("drawer-open-drawer-name");
      }
      if (closestParent.id == "size_inquiry") {
        const sizeInquirySizeVariantField =
          document.querySelector(".variant-size");
        sizeInquirySizeVariantField.style.display = "none";
      }
      toggleAccessibility(childrenTrigger);
      closestParent.classList.remove(settings.activeClass);
    }, 400);
  };

  // Click Handler
  const clickHandler = function (event) {
    const toggle = event.target,
      open = toggle.closest(settings.selectorTrigger),
      close = toggle.closest(settings.selectorClose);

    if (open) {
      openDrawer(open);
    }

    if (close) {
      closeDrawer(close);
    }

    if (open || close) {
      event.preventDefault();
    }
  };

  // Check if contact form was submitted
  if (window.location.toString().includes("?contact")) {
    const sizeInquiryToggle = document.querySelector(
      '[data-component="inquire-toggle"]'
    );
    const productDetailsWrapper = document.querySelector(
      ".product-details-wrapper"
    );
    productDetailsWrapper.classList.add("hidden");
    openDrawer(sizeInquiryToggle);
  }

  // Keydown Handler, handle Escape button
  const keydownHandler = function (event) {
    if (event.key === "Escape" || event.keyCode === 27) {
      let drawers = document.querySelectorAll(settings.selectorTarget),
        i;
      for (i = 0; i < drawers.length; ++i) {
        if (drawers[i].classList.contains(settings.activeClass)) {
          closeDrawer(drawers[i]);
        }
      }
    }
  };
  //
  // Inits & Event Listeners
  //
  document.addEventListener("click", clickHandler, false);
  document.addEventListener("keydown", keydownHandler, false);
};

drawer();
